import React from 'react';
import {
  LinkIcon,
  ShoppingBagIcon,
  HomeIcon,
  CreditCardIcon,
  UserGroupIcon,
  ArchiveBoxIcon,
} from '@heroicons/react/24/outline';

export const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: <HomeIcon /> },
  { name: 'Links', href: '/dashboard/links', icon: <LinkIcon /> },
  {
    name: 'Kartenverwaltung',
    href: '/dashboard/kartenverwaltung',
    icon: <CreditCardIcon />,
  },
  {
    name: 'Bestellungen',
    href: '/dashboard/bestellungen',
    icon: <ShoppingBagIcon />,
  },
];

export const adminNavigation = [
  ...navigation,
  {
    name: 'Bestellbearbeitung',
    href: '/dashboard/bestellbearbeitung',
    icon: <ArchiveBoxIcon />,
  },
  {
    name: 'Benutzerverwaltung',
    href: '/dashboard/benutzerverwaltung',
    icon: <UserGroupIcon />,
  },
  {
    name: 'Kartenadministration',
    href: '/dashboard/kartenadministration',
    icon: <CreditCardIcon />,
  },
];
